var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapTerrain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      background: "#1a2937"
    }
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "mapTerrain_svg__a",
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    rx: 4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A2937",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mapTerrain_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mapTerrain_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#94C0E0",
    xlinkHref: "#mapTerrain_svg__a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1 19c.33 0 .632-.175.79-.456.06-.108.11-.296.11-.419 0-.142-.064-.354-.143-.473l-8.1-12.25A.907.907 0 0010 5a.907.907 0 00-.757.402l-8.1 12.25c-.079.12-.143.331-.143.473 0 .123.05.311.11.42.124.22.41.403.677.446L1.9 19h16.2zM8 12.5L6.5 12l3.222-5L13 11.5l-3-.5-2 1.5z",
    fill: "#314D68",
    fillRule: "nonzero",
    mask: "url(#mapTerrain_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18 2.5H6c-.966 0-1.841.392-2.475 1.025A3.489 3.489 0 002.5 6v12c0 .966.392 1.841 1.025 2.475A3.489 3.489 0 006 21.5h12c.966 0 1.841-.392 2.475-1.025A3.489 3.489 0 0021.5 18V6c0-.966-.392-1.841-1.025-2.475A3.489 3.489 0 0018 2.5z",
    stroke: "#000"
  }))));
}
export default __webpack_public_path__ + "static/media/a70e599a19f90266148ced1915830834-mapTerrain.svg";
export { SvgMapTerrain as ReactComponent };